import React from "react";
import { alliancesArray } from "../../constants/contents";
import "./styles.css";

function Alliances() {
  return (
    <div className="alliances">
      <h1>Tramy trabaja en alianza con:</h1>
      <span>
        {alliancesArray.map((alliance) => (
          <img src={alliance.logo} alt="logo of ally" />
        ))}
      </span>
    </div>
  );
}

export default Alliances;
